// Permissions
export enum PermissionState {
  GRANTED = 'granted',
  DENIED = 'denied',
  PROMPT = 'prompt',
  UNKNOWN = 'unknown',
}

export interface MediaPermissionsStatus {
  camera: PermissionState;
  microphone: PermissionState;
  supported: boolean;
}

// Recording status enum
export enum MediaRecordingStatus {
  IDLE = 'idle',
  ACQUIRING_MEDIA = 'acquiring_media',
  RECORDING = 'recording',
  PAUSED = 'paused',
  STOPPING = 'stopping',
  STOPPED = 'stopped',
  ERROR = 'error',
}

// Recording type enum
export enum RecordingType {
  VIDEO = 'video',
  AUDIO = 'audio',
}

// Media device type enum
export enum MediaDeviceType {
  CAMERA = 'camera',
  MICROPHONE = 'microphone',
}

// Quality preset enum
export enum RecordingQuality {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  ULTRA = 'ultra',
}

// Supported MIME types
export enum SupportedMimeType {
  // Video formats
  VIDEO_WEBM = 'video/webm',
  VIDEO_MP4 = 'video/mp4',
  VIDEO_WEBM_VP8 = 'video/webm;codecs=vp8',
  VIDEO_WEBM_VP9 = 'video/webm;codecs=vp9',
  VIDEO_MP4_H264 = 'video/mp4;codecs=h264',

  // Audio formats
  AUDIO_WEBM = 'audio/webm',
  AUDIO_WAV = 'audio/wav',
  AUDIO_MP3 = 'audio/mp3',
  AUDIO_MP4 = 'audio/mp4',
  AUDIO_WEBM_OPUS = 'audio/webm;codecs=opus',
}

// Error codes for better error handling
export enum RecordingErrorCode {
  PERMISSION_DENIED = 'PERMISSION_DENIED',
  DEVICE_NOT_FOUND = 'DEVICE_NOT_FOUND',
  BROWSER_NOT_SUPPORTED = 'BROWSER_NOT_SUPPORTED',
  RECORDING_FAILED = 'RECORDING_FAILED',
  STREAM_ERROR = 'STREAM_ERROR',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

// Camera facing modes
export enum FacingMode {
  USER = 'user',
  ENVIRONMENT = 'environment',
}

// Constants
export const DEFAULT_TIME_SLICE = 1000; // 1 second (data chunk interval)
export const DEFAULT_FRAME_RATE = 30; // 30 frames per second
export const MAX_RECORDING_DURATION = 300000; // 5 minutes
export const MIN_RECORDING_DURATION = 1000; // 1 second
